<template>
    <div class="bg-wrap" >
        <Banner></Banner>
        <div class="content">
            <div class="title">
                <span >{{title}}</span>
            </div>
            <div class="paragraph">
                <p>{{p1}}</p>
            </div>
            <div class="title title2">
                {{title2}}
            </div>
            <div class="paragraph">
                <p>{{p2}}</p>
            </div>
            <div class="paragraph">
                <p>{{p3}}</p>
            </div>
            <div class="paragraph">
                <p>{{p4}}</p>
            </div>
            <div class="paragraph">
                <p>{{p5}}</p>
            </div>
            <div class="title title2">
                {{title3}}
            </div>
            <div class="paragraph">
                <p>{{p6}}</p>
            </div>
            <div class="paragraph nospace">
                <p>{{p7}}</p>
            </div>
            <div class="paragraph">
<!--                <p>{{p8}}</p>-->
                <ul>
                    <li>{{p8}}</li>
                    <li>{{p9}}</li>
                    <li>{{p10}}</li>
                    <li>{{p11}}</li>
                    <li>{{p12}}</li>
                    <li>{{p13}}</li>
                </ul>


            </div>
            <div class="paragraph nospace">
                <p>{{p14}}</p>
            </div>
            <div class="paragraph nospace">
                <p>{{p15}}</p>
            </div>
            <div class="paragraph">
                <ul>
                    <li>{{p16}}</li>
                    <li>{{p17}}</li>
                    <li>{{p18}}</li>
                    <li>{{p19}}</li>
                    <li>{{p20}}</li>
                    <li>{{p21}}</li>
                </ul>
            </div>

            <div class="title title2">
                {{title4}}
            </div>
            <div class="paragraph">
                <p>{{p22}}</p>
            </div>
            <div class="paragraph">
                <p>{{p23}}</p>
            </div>
            <div class="paragraph">
                <p>{{p24}}</p>
            </div>
            <div class="paragraph">
                <p>{{p25}}</p>
            </div>
            <div class="paragraph">
                <p>{{p26}}</p>
            </div>
            <div class="paragraph">
                <p>{{p27}}</p>
            </div>
            <div class="paragraph">
                <p>{{p28}}</p>
            </div>
            <div class="paragraph">
                <p>{{p29}}</p>
            </div>
            <div class="paragraph">
                <p>{{p30}}</p>
            </div>
            <div class="title title2">
                {{title5}}
            </div>

            <div class="paragraph">
                <p>{{p31}}</p>
            </div>

            <div class="paragraph bold" >
                <p>{{p32}}</p>
            </div>

            <div class="btn">
                <label @click="back">{{btn1}}</label>
<!--                <label @click="go">{{btn2}}</label>-->
            </div>
        </div>
    </div>
</template>

<script>
    import Banner from "@/components/ksd/fragment/Banner";
    import {ksdDocPrivacy} from "@/assets/js/api";

    export default {
        data() {
            return {
                title:"隐私安全管理政策",
                p1:"一旦您选择使用或继续使用本协议项下爱优医健康管理平台服务，即表示您认可并接受本《本“爱优医健康管理平台”隐私政策》现有内容及其可能随时更新的内容，同意我们按照本《“爱优医健康管理平台”隐私政策》收集、使用、披露、储存和分享，或以其他方式运用您的相关信息。",
                p2:"1.1您在使用“爱优医健康管理平台”服务时，会向“爱优医健康管理平台”平台提供个人信息，例如您所在省份、城市、姓名、所在医院、科室、手机号等个人信息。您同意“爱优医健康管理平台”平台在您使用服务的过程中获取信息。请注意，“爱优医健康管理平台”平台只收集与其提供服务有关的信息，此类信息包括但不限于：",
                p3:"1.注册信息—您在注册并使用“爱优医健康管理平台”平台时须向我们提供您的个人信息，这些信息包括但不限于您的所在省份、城市、姓名、所在医院、科室、手机号等个人信息； ",
                p4:"2.本地存储（日志信息）——当您使用”爱优医健康管理平台”平台进行点击浏览或搜索服务时，我们可能会使用浏览器网络存储等机制（包括 HTML 5）和应用程序数据缓存，在您的设备上收集信息（包括个人信息）并进行本地存储。例如您输入的搜索关键词信息和点击的链接，您上传的文字资料、图片、视频等信息以及您的IP地址、使用的语言、硬件，设备信息、操作系统的版本、网络运营商的信息、您访问服务的日期、时间、时长等。",
                p5:"1.2个人信息及作品数据进行脱敏处理——“爱优医健康管理平台”在收到您的个人信息及作品后，会对您的信息进行脱敏化处理并有义务对其进行保存备份，保存及备份时间自您提交信息之日起的2年，届时平台将予以删除。",
                p6:"2.1“爱优医健康管理平台”承诺，会按本协议约定方式以高度的勤勉义务对待和使用所收集到的个人信息、作品信息及影像资料，除了“K速达-中国高血压健康管理项目”的主办方或支持方以其关联实体对本平台收集的上述内容具有使用权，其它非经您授权同意，不会向“爱优医健康管理平台”及其关联公司以外的其他任何公司、组织或个人透露、分享或转让您的个人信息、作品信息及影像资料。",
                p7:"2.2“爱优医健康管理平台”在以下情形时，可以披露信息：",
                p8:"按本协议约定方式使用时。",
                p9:"事先获得您的明确授权或同意。",
                p10:"根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露。",
                p11:"如果您出现违反中国有关法律或者网站政策的情况，需要向第三方披露。",
                p12:"在不透露单个用户隐私资料的前提下，“爱优医健康管理平台”平台有权对整个用户数据库、作品信息及影像资料进行分析，其相关数据分析报告“K速达-中国高血压健康管理项目”的主办方或支持方及其关联实体具有使用权；",
                p13:"其他“爱优医健康管理平台”平台认为合适的且法律并不禁止的披露。",
                p14:"2.3共享、转让、公开披露个人信息时事先征得授权同意的例外",
                p15:"以下情形中，共享、转让、公开披露个人信息无需事先征得用户的授权同意：",
                p16:"与国家安全、国防安全有关的：",
                p17:"与公共安全、公共卫生、重大公共利益有关的；",
                p18:"与犯罪侦查、起诉、审判和判决执行等有关的；",
                p19:"出于用户主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的",
                p20:"用户自行向社会公众公开的个人信息；",
                p21:"从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道以及用户在其它公开平披露的个人信息。",
                p22:"3.1“爱优医健康管理平台”遵循国家网络安全等级保护制度，履行相应的安全保护义务，避免网络遭受相应的干扰、破坏或者未经授权的访问，防止用户信息泄露或者被盗窃、篡改，切实安全持续保存您的个人信息。",
                p23:"3.2您的个人信息均存储于中华人民共和国境内。",
                p24:"3.3“爱优医健康管理平台”遵循合法、正当、必要的原则（最小化原则）收集、使用您的个人信息，并通过用户协议和隐私政策明确告知收集、使用信息的目的、方式和范围，并征得您的同意。",
                p25:"3.4“爱优医健康管理平台”高度重视您的个人信息安全，制定了相应的内部安全管理制度和操作规程，并对网络安全负责人进行严格的背景和资历审查，切实落实网络安全保护责任。“爱优医健康管理平台”平台会采取适当的安全措施和技术措施，确保所收集的个人信息安全，防止信息泄露、毁损、丢失。根据“爱优医健康管理平台”平台的内部安全管理制度，一旦发生或可能发生您的个人信息泄露、毁损、丢失的情况时，“爱优医健康管理平台”平台会列为重大安全事件，一经发现会立即采取补救措施，根据法律的有关规定和本协议的相关规定，及时告知相关用户并向有关部门报告。",
                p26:"3.5“爱优医健康管理平台”会对员工进行数据安全的意识培养和安全能力的培训和考核，会对处理个人信息的员工进行身份认证及权限控制，并会与接触您的个人信息的员工、合作伙伴签署保密协议，明确岗位职责及行为准则，若有违反保密协议的行为，会被立即终于与“爱优医健康管理平台”平台的合作关系，并会追究相关法律责任，对接触个人信息人员在离岗时也提出了保密要求。",
                p27:"3.6责任减免条款 “爱优医健康管理平台”在竭尽所能保护用户个人信息的同时，也注意到由于互联网行业本身发展较快，加之可能存在各种恶意攻击手段和一些技术上的限制，我们不能始终确保您的信息百分之百安全。当您在使用我们的产品或接受服务的同时，有可能在“爱优医健康管理平台”所能控制的范围之外出现安全问题。",
                p28:"3.7“爱优医健康管理平台”一旦发现其网络产品、服务存在或可能存在安全缺陷、漏洞等风险，并且会威胁您个人信息安全时，应当立即采取补救措施，根据法律的有关规定和本协议的相关规定，及时告知相关用户并向有关部门报告。同时，“爱优医健康管理平台”会制定相应的网络安全事件应急预案，及时处置系统漏洞、计算机病毒、网络攻击、网络侵入等安全风险，在发生危害网络安全的事件时，我们会立即启动应急预案，采取相应的补救措施，并按照规定向有关部门报告。",
                p29:"3.8如若发生个人信息安全事件，“爱优医健康管理平台”会根据相关法律法规的要求，对安全事件进行调查和评估，及时向您告知安全事件的基本情况和可能的影响、我们已采取或将要采取的处理措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以短信、电话、邮件等联系方式告知您，难以逐一告知时我们会采取合理、有效的方式发布公告。",
                p30:"3.9您在使用“爱优医健康管理平台”服务时请勿将自认为隐私的信息发表、上传至“爱优医健康管理平台”，也不可将该等信息通过“爱优医健康管理平台”的服务器传播给他人，若因您该等行为引起隐私泄露，由您自行承担责任。",
                p31:"当“爱优医健康管理平台”的服务内容服务模式变动以及国家法律政策的变动导致个人信息处理的方式发生重大变更时， 或其他影响到您的个人信息权的事项发生时，我们可能对本隐私政策进行修订，该等修订构成本隐私政策的一部分，并具有溯及力。我们会在本页面上或通过其他我们认为合适的方式发布对本隐私政策所做的任何变更。若您继续使用我们的产品和/或服务，即表示您同意接受修订后的本隐私政策的约束。",
                p32:"“我已阅读、并完全理解“爱优医健康管理平台”提供的《隐私政策》（包括对其不时作出的修订），并同意对我具备法律约束力。我同意其收集和处理我在其平台上填报或以其他方式向其提供的科学、医学和疾病相关传递事宜有关的资料”。",


                title2:"一、信息收集",
                title3:"二、信息的使用、共享与披露",
                title4:"三、信息的保存和保护",
                title5:"四、隐私政策的修订",

                btn1:"好的",
                // btn1:"不同意",
                // btn2:"同意",
            };
        },
        components:{
          Banner
        },
        mounted(){
        },
        methods: {
            back(){
                this.$router.go(-1)
            },
            go(){
                this.privacyDone(this.$store.state.ksd_docId)
            },
            async privacyDone(docId){
                const res = await ksdDocPrivacy({docId})
                console.log(res,"asdcasdc")
                if(res.data.success){
                    this.$router.replace("docIndex")
                }else{
                    this.$toast(res.data.message)
                }
            }

        }
    };
</script>

<style scoped lang="scss">
    .bg-wrap {
        width: 100%;
        height: 100vh;
        background: #fff url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/bg.png") no-repeat;
        background-size: 100% 100%;
        font-size: 16px;
        overflow: scroll;
    }
    .content{
        width: 90%;
        margin: 0 auto;
    }
    .title{
        color: #326F51;
        font-size: 20px;
        font-weight: bold;
        margin: 10px;
    }
    .title2{
        text-align: left;
        margin: 10px 0 10px -5%;
        font-size: 16px;
    }
    .paragraph{
        /*text-indent: 30px;*/
        font-size: 12px;
        text-align: left;
        line-height: 20px;
        margin-bottom: 10px;
    }
    .paragraph2{
        font-size: 12px;
        text-align: left;
        line-height: 20px;
    }
    p{
        margin: 2px 0;
    }
    .btn{
        display: flex;
        flex-flow: row nowrap;
        justify-content: center;
        margin: 20px ;
        label{
            display: block;
            margin: 0 30px;
            padding: 5px 15px;
            color: #FFF;
            border-radius: 5px;
            font-size: 14px;
        }
        label:first-child{
            background: #b3b3b3;
        }
        label:last-child{
            background: #326F51;
        }
    }
    .bold{
        font-weight: bold;
    }
    .space{
        text-indent: 20px;
    }
    .nospace{
        margin-bottom: 0;
    }

    ul{
        list-style: decimal;
        margin: 0;
        padding-left: 25px;
    }
</style>

